(function() {
    const agentesInput = document.querySelector('#agente');

    if(agentesInput) {
        let agentes = [];
        let agentesFiltrados = [];

        const listadoAgentes = document.querySelector('#listado-agentes');
        const agenteHidden = document.querySelector('[name="colaborador_id"]');

        obtenerAgentes();
        agentesInput.addEventListener('input', buscarAgentes);

        // Si ya hay un agente guardado (editar)
        if(agenteHidden.value) {
            (async () => {
                const agente = await obtenerAgente(agenteHidden.value);
                const { nombre, apellido } = agente;

                const agenteDOM = document.createElement('LI');
                agenteDOM.classList.add(
                    'listado-ponentes__ponente',
                    'listado-ponentes__ponente--seleccionado'
                );
                agenteDOM.textContent = `${nombre} ${apellido}`;

                listadoAgentes.appendChild(agenteDOM);
            })();
        }

        async function obtenerAgentes() {
            const url = '/api/agentes';
            const respuesta = await fetch(url);
            const resultado = await respuesta.json();
            formatearAgentes(resultado);
        }

        async function obtenerAgente(id) {
            const url = `/api/agente?id=${id}`;
            const respuesta = await fetch(url);
            const resultado = await respuesta.json();
            return resultado;
        }

        function formatearAgentes(arrayAgentes = []) {
            agentes = arrayAgentes.map(agente => {
                return {
                    nombre: `${agente.nombre.trim()} ${agente.apellido.trim()}`,
                    id: agente.id
                };
            });
        }

        function buscarAgentes(e) {
            const busqueda = e.target.value;

            if(busqueda.length >= 1) {
                const expresion = new RegExp(busqueda, 'i');
                agentesFiltrados = agentes.filter(agente => {
                    if(agente.nombre.toLowerCase().search(expresion) !== -1) {
                        return agente;
                    }
                });
            } else {
                agentesFiltrados = [];
            }

            mostrarAgentes();
        }

        function mostrarAgentes() {
            while(listadoAgentes.firstChild) {
                listadoAgentes.removeChild(listadoAgentes.firstChild);
            }

            if(agentesFiltrados.length > 0) {
                agentesFiltrados.forEach(agente => {
                    const agenteHTML = document.createElement('LI');
                    agenteHTML.classList.add('listado-ponentes__ponente');
                    agenteHTML.textContent = agente.nombre;
                    agenteHTML.dataset.agenteId = agente.id;
                    agenteHTML.onclick = seleccionarAgente;

                    listadoAgentes.appendChild(agenteHTML);
                });
            } else {
                const noResultados = document.createElement('P');
                noResultados.classList.add('listado-ponentes__no-resultado');
                noResultados.textContent = 'No hay resultados para tu búsqueda';
                listadoAgentes.appendChild(noResultados);
            }
        }

        function seleccionarAgente(e) {
            const agente = e.target;

            const agentePrevio = document.querySelector(
                '.listado-ponentes__ponente--seleccionado'
            );
            if(agentePrevio) {
                agentePrevio.classList.remove('listado-ponentes__ponente--seleccionado');
            }

            agente.classList.add('listado-ponentes__ponente--seleccionado');
            agenteHidden.value = agente.dataset.agenteId;
        }
    }
})();
